import React, { useState } from 'react'
import { Send } from 'lucide-react'
import { useAuth } from '../../context/AuthContext'
import toast from 'react-hot-toast'

const Transfer = () => {
  const { profile } = useAuth()
  const [formData, setFormData] = useState({ recipient: '', amount: '', note: '' })
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    toast.info('Transfer feature coming soon!')
  }

  return (
    <div className="max-w-2xl mx-auto space-y-6">
      <h1 className="text-2xl font-bold">Transfer Money</h1>
      <div className="card">
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="input-group">
            <label className="input-label">Recipient Username</label>
            <input type="text" value={formData.recipient} onChange={e => setFormData({...formData, recipient: e.target.value})} placeholder="Enter username" required />
          </div>
          <div className="input-group">
            <label className="input-label">Amount</label>
            <input type="number" step="0.01" value={formData.amount} onChange={e => setFormData({...formData, amount: e.target.value})} placeholder="0.00" required />
            <p className="input-hint">Available: ${profile?.balance || 0}</p>
          </div>
          <div className="input-group">
            <label className="input-label">Note (Optional)</label>
            <textarea value={formData.note} onChange={e => setFormData({...formData, note: e.target.value})} placeholder="What's this for?" rows="3" />
          </div>
          <button type="submit" disabled={loading} className="btn btn-primary w-full">
            <Send className="w-5 h-5" />
            Send Money
          </button>
        </form>
      </div>
    </div>
  )
}

export default Transfer